import edu from "./education/fr";
import lib from "./library/fr";
import al from "./assets/fr";
import vm from "./videoMoments/fr";
import iv from "./interview/fr";
import lvl from "./level/fr";
import pm from "./practice/fr";
// Phase 5.3 — French (Français)
const fr = {
  footer: { forSchools: "Pour les écoles", tagline: "Ta vie devient ton cours de langue.", eu: "Conçu pour l'UE 🇪🇺 · RGPD d'abord · Nous ne conservons jamais tes photos ni ta voix.", product: "Produit", signIn: "Se connecter", getStarted: "Commencer", legal: "Mentions légales", privacy: "Politique de confidentialité", terms: "Conditions d'utilisation" },
  cookie: { title: "Ta vie privée compte pour nous 🍪", body: "GetFluentLoop utilise des cookies essentiels pour te garder connecté. Nous ne vendons jamais tes données et nous ne conservons jamais tes photos ni tes enregistrements vocaux bruts. Consulte notre", link: "Politique de confidentialité", end: ".", accept: "Accepter", decline: "Refuser" },
  cefr: {"A1": "Je connais quelques mots", "A2": "Phrases simples du quotidien", "B1": "Je peux tenir une conversation simple", "B2": "Je suis assez à l'aise", "C1": "Je suis très à l'aise", "C2": "Presque natif"},
  landing: { imgAlt: "Apprenant", streakBadge: {"one": "{count} jour d'affilée !", "other": "{count} jours d'affilée !"}, heroSub: "Apprends à partir de ce que tu vois, penses, dis, lis et vis, pendant que GetFluentLoop adapte la langue à ta vraie vie. Commence gratuitement en quelques secondes.","freeTag": "GRATUIT", "featJournal": "Journal vocal", "featToday": "Aujourd'hui intelligent", "descLoop": "Tu vois quelque chose ? Prends-le en photo et apprends le mot instantanément.", "descFriend": "Une idée en tête ? Dis-la naturellement : parle de ta vie dans la langue que tu apprends.", "descLens": "Lis les panneaux, menus, objets et scènes autour de toi, et apprends grâce à eux.", "descJournal": "Raconte ta journée avec tes propres mots, à l'oral ou à l'écrit. Écoute-la naturellement dans ta nouvelle langue.", "descToday": "Reviens demain : ton Cerveau d'apprentissage prépare la prochaine petite leçon autour de ce qui compte pour toi.", "mockLearned": "Appris aujourd'hui", "mockGloss": "L'arbre est très grand."},
  dash: { freezeSaved: {"one": "🛡️ Un gel de série a sauvé ta série de {count} jour !", "other": "🛡️ Un gel de série a sauvé ta série de {count} jours !"},"hey": "Salut {name} 👋", "heyAnon": "Salut 👋", "learning": "Tu apprends : {lang} · Niveau {level}", "recap": "Ta semaine en bref", "upgrade": "Passer à Pro", "todayLoop": "Le Loop du jour", "todayLoopSub": "Ta session personnalisée de 5 minutes : commence maintenant", "classAssignments": "Devoirs de classe", "viewAll": "Tout voir →", "continue": "Continuer", "start": "Commencer", "allCaught": "Tout est à jour, bravo ! 🎉", "momentum": "Ta dynamique", "freezeHelp": "Les gels de série protègent ta série si tu manques un jour", "freezes": {"one": "{count} gel", "other": "{count} gels"}, "streakCalendar": "Voir le calendrier de série →", "totalXp": "XP au total", "wordsLearned": "mots appris", "dueForReview": "à réviser →", "captures": "captures", "conversations": "conversations", "accentTrend": "Évolution de l'accent", "noScores": "Pas encore de score : essaie", "noScoresEnd": ".", "recent": "Activité récente", "nothingYet": "Rien pour l'instant. Commence à capturer !", "jumpBack": "Reprends là où tu t'es arrêté"},
  nudge: {"streakTitle": {"one": "Garde ta série de {count} jour !", "other": "Garde ta série de {count} jours !"}, "streakSub": "Fais ton Loop du jour pour ne pas la perdre.", "startLoop": "Lancer le Loop", "dueTitle": {"one": "{count} mot à réviser", "other": "{count} mots à réviser"}, "dueSub": "Un Loop de 2 minutes les ancre dans ta mémoire à long terme.", "reviewNow": "Réviser maintenant"},
  tour: {"t1": "Bienvenue sur GetFluentLoop ! 🎉", "b1": "Une appli qui transforme ton quotidien en cours de langue : chaque fonctionnalité alimente un même lexique.", "t2": "Pointe ta caméra", "b2": "LanguageLoop transforme tout ce qui t'entoure en mot : prends une photo et obtiens le mot, une phrase et la prononciation.", "t3": "Pratique pour de vrai", "b3": "Discute avec ton Roommate IA, évalue ton accent, débats d'un sujet et teste-toi sur tes propres mots.", "t4": "Le Loop du jour", "b4": "Tu ne sais pas par où commencer ? Touche le Loop du jour pour une session personnalisée de 5 minutes, chaque jour.", "t5": "Construis une série", "b5": "Pratique chaque jour pour faire grandir ta série, et mets de côté des gels pour qu'une journée chargée ne la casse jamais.", "back": "Retour", "next": "Suivant", "start": "Commencer à apprendre", "skip": "Passer la visite"},
  vocabSrc: {"manual": "Ajouté par toi", "mission": "Mission", "word_explorer": "Explorateur de mots", "object_lens": "FluentLens · Objet", "scene_lens": "FluentLens · Scène", "text_lens": "FluentLens · Texte", "fluent_friend_live": "Ami en direct"},
  common: {
    save: "Enregistrer", cancel: "Annuler", add: "Ajouter", addSelected: "Ajouter la sélection",
    addAll: "Ajouter les mots utiles", delete: "Supprimer", edit: "Modifier", retake: "Reprendre la photo",
    scanAgain: "Scanner à nouveau", continue: "Continuer", back: "Retour", next: "Suivant",
    close: "Fermer", loading: "Chargement…", search: "Rechercher", logout: "Se déconnecter",
    settings: "Paramètres", listen: "Écouter", stop: "Arrêter", added: "Ajouté",
  },
  nav: {
    educationadmin: "Admin Éducation",
    more: "Plus",
    dashboard: "Tableau de bord", today: "Aujourd'hui", languageloop: "LanguageLoop",
    fluentlens: "FluentLens", roommate: "Roommate", accentcoach: "AccentCoach",
    debategym: "DebateGym", quizforge: "QuizForge", story: "Histoire",
    "vocab bank": "Vocabulaire", "discovery lab": "Discovery Lab", assignments: "Devoirs", myclasses: "Mes classes", teacher: "Enseignant", journal: "Journal", friend: "Ami",
  },
  auth: { welcomeBack: "Bon retour !", welcomeNew: "Bienvenue sur GetFluentLoop ! 🎉",
    signInTitle: "Bon retour", signUpTitle: "Crée ton compte",
    signInSub: "Connecte-toi pour continuer à apprendre.", signUpSub: "Commence à apprendre en moins d'une minute.",
    continueWithGoogle: "Continuer avec Google", or: "OU", yourName: "Ton nom",
    email: "E-mail", password: "Mot de passe", iSpeak: "Je parle", imLearning: "J'apprends",
    myLevel: "Mon niveau", createAccount: "Créer un compte", signIn: "Se connecter",
    acceptTerms: "J'accepte les Conditions et la Politique de confidentialité.",
    haveAccount: "Tu as déjà un compte ?", noAccount: "Nouveau ici ?",
  },
  onboarding: {
    allSet: "Tout est prêt ! 🎉",
    welcome: "Bienvenue sur GetFluentLoop", title: "Configurons ton profil",
    subtitle: "Dis-nous ce que tu apprends.", iSpeak: "Je parle",
    imLearning: "J'apprends", level: "Niveau", finish: "Commencer à apprendre",
    allSet: "Tout est prêt ! 🎉",
  },
  settings: {
    title: "Paramètres", interfaceLanguage: "Langue de l'interface",
    interfaceLanguageHelp: "La langue des menus, boutons et messages. Cela ne change pas ce que tu apprends.",
    learning: "Apprentissage", native: "Langue maternelle", level: "Niveau",
    learningProfiles: "Profils d'apprentissage",
    learningProfilesHelp: "Gère plusieurs langues sur un seul compte. Changer de profil ne modifie que ton contexte d'apprentissage — ton compte, ton rôle et tes établissements restent identiques.",
    addProfile: "Ajouter un profil de langue", switch: "Changer", active: "Actif",
    createAndSwitch: "Créer et activer", nameOptional: "Nom (facultatif)",
    pickDifferent: "Choisis deux langues différentes à parler et à apprendre.",
    profileSwitched: "Profil d'apprentissage changé",
  },
  lens: {
    home: "FluentLens", tagline: "Pointe ta caméra vers le monde et apprends la langue qui t'entoure.",
    textLens: "Lentille Texte", objectLens: "Lentille Objet", studyLens: "Lentille Étude",
    sceneLens: "Lentille Scène", takePhoto: "Prendre une photo", uploadImage: "Importer une image",
    translate: "Traduire", explain: "Expliquer", quizMe: "Teste-moi", describe: "Décrire",
    identifyCount: "Identifier et compter", learnVocab: "Apprendre le vocabulaire",
    saveScan: "Enregistrer dans l'archive", archive: "Archive", usefulVocab: "Vocabulaire utile",
    naturalTranslation: "Traduction naturelle", gist: "L'essentiel", check: "Vérifier",
    addWord: "Ajouter le mot", addRelated: "Ajouter les mots liés", wordsAround: "Mots associés",
    whereThings: "Où se trouvent les choses", suggestedAnswer: "Réponse suggérée",
  },
  mission: {
    speak: "Parler", type: "Écrire", startRecording: "Appuie pour parler", stop: "Arrêter",
    retry: "Réessayer", usefulPhrases: "Phrases utiles", wordsToRemember: "Mots à retenir",
    completeMission: "Terminer la mission", nextStep: "Étape suivante", recap: "récapitulatif d'apprentissage",
    showRecap: "Afficher", hideRecap: "Masquer", typeFirst: "Écris ta première réponse pour commencer.",
    speakFirst: "Appuie sur le micro et dis ta première phrase pour commencer.",
    typeReply: "Écris ta réponse…",
  },
  home: {
    badge: "🇪🇺 Conçu dans l'UE · Confidentialité d'abord · Pensé pour le monde",
    heroPre: "Ta vie devient", heroPost: "ton cours de", heroWord: "langue",
    getStarted: "Commencer", signIn: "Se connecter", dashboard: "Tableau de bord",
    tryFree: "Essayer LanguageLoop gratuitement", startLearning: "Commencer à apprendre",
    privacy: "Aucune photo ni aucun enregistrement n'est jamais conservé.",
    bundlesTitle: "Tout nourrit une seule boucle d'apprentissage.",
    bundlesSub: "Découvre un mot n'importe où, explore-le et retiens-le. Chaque fonctionnalité partage un même lexique, une mémoire de ce que tu sais et un plan quotidien serein.",
    priceSub: "Tout inclus. Résiliable à tout moment.", startNow: "Commencer",
  },
  pilot: {
    daysRemaining: { one: "{count} jour restant", other: "{count} jours restants" },
  },
  today: { dueSoon: "Bientôt à rendre", overdue: "En retard", continueMission: "Continue ta mission de classe", yourMission: "Ta mission de classe", minutes: {"one": "~{count} min", "other": "~{count} min"}, stepsProgress: "{done}/{total} étapes", wordProgress: "Mot {n} / {total}", unlockPro: "Débloquer avec Pro", skipForNow: "Passer pour l'instant", weHeard: "On a entendu :", skip: "Passer", snapHint: "Prends en photo un objet autour de toi pour ajouter un nouveau mot à ton lexique.", doLater: "Je le ferai plus tard", bonusXp: {"one": "+{count} XP de bonus", "other": "+{count} XP de bonus"}, micUnavailable: "Micro indisponible.", scoringFailed: "L'évaluation a échoué.", paywallReason: "L'évaluation de la prononciation fait partie de GetFluentLoop Pro.",
    title: "Ta session du jour", subtitle: "Ta session personnalisée de 5 minutes.",
    dayStreak: { one: "jour d'affilée", other: "jours d'affilée" }, streakText: {"one": "{count} jour d'affilée", "other": "{count} jours d'affilée"}, startLoop: "Commencer la session du jour", reveal: "Afficher la réponse",
    gotIt: "Je savais", missedIt: "Raté", sayItOut: "Dis-le à voix haute", hearIt: "Écouter",
    skip: "Passer", continue: "Continuer", loopComplete: "Session terminée !",
    loopCompleteToday: "Session du jour terminée !", comeBack: "Reviens demain.",
    backToDashboard: "Retour au tableau de bord", word: "Mot", reviewWords: "Réviser les mots",
    saySentence: "Dis une phrase", captureNew: "Capture du nouveau",
    openCamera: "Ouvrir la caméra", learnNewWord: "Apprends un nouveau mot", practiceAgain: "S'entraîner à nouveau",
  },
  wordExplorer: {
    script: "Alphabet",
    scriptSaved: "Préférence d'alphabet enregistrée",
    pos: {
      noun: "nom",
      verb: "verbe",
      adjective: "adjectif",
      adverb: "adverbe",
      pronoun: "pronom",
      preposition: "préposition",
      conjunction: "conjonction",
      phrase: "expression",
      other: "autre",
      related: "apparenté",
    },
    labels: {
      present: "Présent",
      past_compose: "Passé composé",
      past_preterite: "Passé (pretérito)",
      imperfect: "Imparfait",
      future: "Futur",
      conditional: "Conditionnel",
      subjunctive: "Subjonctif",
      singular: "Singulier",
      plural: "Pluriel",
      nominative: "Nominatif",
      genitive: "Génitif",
      dative: "Datif",
      accusative: "Accusatif",
      instrumental: "Instrumental",
      prepositional: "Prépositionnel",
      present_imperfective: "Présent (imperfectif)",
      future_perfective: "Futur (perfectif)",
      past: "Passé",
      imperative: "Impératif",
      forms: "Formes",
      masculine: "masculin",
      feminine: "féminin",
      neuter: "neutre",
      short_m: "courte m.",
      short_f: "courte f.",
      short_forms: "Formes courtes",
    },
    explore: "Explorer",
    exploreWord: "Explorer « {word} »",
    title: "Explorateur de mots",
    howChanges: "Comment ce mot change",
    seeMoreForms: "Voir plus de formes",
    family: "Famille de mots",
    usage: "Comment on l'utilise vraiment",
    traps: "Pièges courants",
    examples: "Exemples naturels",
    save: "Ajouter au vocabulaire",
    saved: "Ajouté au vocabulaire",
    aiAssisted: "Formes assistées par IA",
    aiAssistedHelp: "Ces formes ont été générées et vérifiées automatiquement.",
    unlock: "Débloque l'Explorateur de mots avec Pro",
    unlockSub: "Toutes les formes utiles, la famille de mots, l'usage réel, les pièges et plus d'exemples.",
    unlockCta: "Débloquer avec Pro",
    more: "Plus d'usages et d'exemples",
    loading: "Exploration…",
    failed: "Impossible d'explorer ce mot. Vérifie l'orthographe.",
    back: "Vocabulaire",
    listen: "Écouter",
    alsoMeans: "Aussi",
  },
  vocab: { markKnown: "Marquer comme connu",
    title: "Vocabulaire", subtitle: "Chaque mot que tu as appris.", searchWords: "Rechercher des mots…",
    all: "Tous", known: "Connus", learning: "En cours", removed: "Supprimé", markKnown: "Marquer comme connu",
    empty: "Aucun mot pour l'instant. Captures-en avec FluentLens !",
  },
  journal: {
    title: "Journal vocal", tagline: "Raconte ta vie. Apprends à la dire.",
    speak: "Parler", type: "Écrire", recording: "Enregistrement… appuie pour arrêter",
    typePlaceholder: "Écris dans ta langue…",
    intro: "Parle de ta journée, de tes projets ou de ton ressenti, dans ta langue.",
    review: "Vérifie ta pensée", reviewHelp: "Vérifie la transcription et corrige avant la traduction.",
    retry: "Réenregistrer", seeHowToSay: "Voir comment le dire",
    whatYouSaid: "Ce que tu as dit", howToSay: "Comment le dire en {lang}",
    practice: "Entraîne-toi à le dire", practicing: "Enregistrement de ton essai…", playYours: "Écoute ton essai",
    usefulWords: "Mots utiles", usefulPhrases: "Expressions utiles", grammar: "Grammaire à remarquer",
    actions: "Actions possibles", saveEntry: "Enregistrer au journal", saved: "Enregistré dans ton journal",
    archive: "Ton journal", empty: "Pas encore d'entrées — dis ou écris ta première pensée.",
    newEntry: "Nouvelle entrée", rename: "Renommer", deleted: "Entrée supprimée",
    micDenied: "Micro indisponible — écris plutôt.", analyzing: "Recherche de la formulation naturelle…",
    transcribing: "Écoute…",
  },
  friend: {
    live: {
      "premium": "Fluent Friend est une fonctionnalité premium.",
      "voiceUnavailable": "Voix indisponible pour le moment.",
      "genericError": "Une erreur s'est produite. Réessaie.",
      "start": "Démarrer une conversation en direct",
      "tag": "En direct",
      "intro": "Parle directement dans la langue que tu apprends. Fluent Friend fera vivre la conversation. Si tu bloques, utilise « Aide-moi à le dire ».",
      "ideas": "Idées pour commencer",
      "speak": "Parler",
      "stop": "Arrêter",
      "type": "Écris dans la langue que tu apprends…",
      "help": "Aide-moi à le dire",
      "helpTitle": "Dis-le dans ta langue",
      "helpPlaceholder": "Dis ou écris ce que tu veux dire…",
      "helpGo": "Montre-moi comment le dire",
      "helped": "Tu voulais dire",
      "end": "Terminer la conversation",
      "voice": "Voix de l'ami",
      "listening": "À l'écoute…",
      "understanding": "Compréhension…",
      "thinking": "Réflexion…",
      "retry": "Réessayer",
      "replyFailed": "Fluent Friend n'a pas pu répondre ; ton message est conservé.",
      "sttFailed": "Nous n'avons pas compris. Réessaie ou écris.",
      "meaning": "Voir le sens",
      "saved": "Conversation enregistrée.",
      "recapTitle": "Ce que tu as pratiqué",
      "keep": "Expressions à garder",
      "addAll": "Tout ajouter",
      "moreNatural": "Une chose à dire plus naturellement",
      "handledWell": "Quelque chose que tu as bien géré",
      "practiceAgain": "À pratiquer à nouveau",
      "starter": {
        "day": "Raconte-moi ta journée",
        "plans": "Qu'est-ce que tu prévois ?",
        "happened": "Quelque chose d'intéressant est arrivé ?",
        "work": "On parle du travail ou des études ?",
        "forward": "Qu'est-ce que tu attends avec impatience ?"
      }
    },
    title: "Fluent Friend", tagline: "Parle de ta vie. Apprends par la conversation.",
    intro: "Parle naturellement dans ta langue. Fluent Friend t'aide à le dire en {lang}, puis poursuit la conversation.",
    introText: "Écris naturellement dans ta langue. Dis ce que tu veux vraiment exprimer : Fluent Friend t'aide à le dire en {lang}, puis poursuit la conversation.",
    speak: "Parler", type: "Écrire", send: "Envoyer", placeholder: "Dis quelque chose dans ta langue…",
    reviewHint: "Vérifie ce que tu as dit, puis envoie.", youCouldSay: "Tu pourrais dire",
    showMeaning: "Voir le sens", hideMeaning: "Masquer le sens",
    recap: "Ce que tu as pratiqué", newChat: "Nouvelle conversation", conversations: "Conversations",
    empty: "Pas encore de conversations — commence par parler de ta journée.",
    startersTitle: "Tu ne sais pas par où commencer ?",
    starters: ["Parle-moi de ta journée", "Quelque chose en tête ?", "Qu'est-ce que tu prévois ?", "On parle du travail ?", "Dis-moi une bonne nouvelle", "Qu'est-ce que tu attends avec impatience ?"],
    words: "Mots utiles", phrases: "Expressions utiles", expressions: "Tournures naturelles",
    grammar: "Grammaire à remarquer", practiceAgain: "À revoir",
    thinking: "Fluent Friend répond…", recording: "Enregistrement… appuie pour arrêter",
    micDenied: "Micro indisponible — écris plutôt.",
  },
  teacher: { dashboard: "Tableau de bord enseignant", myClasses: "Mes classes" },
  education: {
    title: "FluentLoop pour l'éducation",
    pilotLine: "Programme pilote scolaire de 90 jours — gratuit pour les établissements vérifiés.",
    apply: "Candidater au pilote de 90 jours", submitting: "Envoi…",
  },
  assignments: {
    title: "Mes devoirs", subtitle: "Les missions que ton enseignant t'a attribuées.",
    empty: "Aucun devoir pour l'instant 🎉", emptySub: "Quand ton enseignant attribue une mission, elle apparaît ici.",
    doTodayLoop: "Faire la session du jour", toDo: "À faire", inProgress: "En cours", completed: "Terminés",
    start: "Commencer", continue: "Continuer", done: "Terminé", late: "(en retard)",
    overdue: "En retard", dueToday: "À rendre aujourd'hui", dueSoon: "Bientôt dû", scheduled: "Planifié",
  },
  label: {
    gist: "L'essentiel", vocabulary: "Vocabulaire", usefulPhrases: "Phrases utiles", grammar: "Grammaire",
    verbs: "Verbes", adjectives: "Adjectifs", idioms: "Expressions et collocations", relatedWords: "Mots associés",
    example: "Exemple", naturalTranslation: "Traduction naturelle", whereThings: "Où se trouvent les choses",
    reanalyze: "Réanalyser", save: "Enregistrer", plural: "pluriel",
  },
  missionRun: {
    breadcrumb: "Devoirs", notAvailable: "Cette mission n'est pas disponible pour toi.",
    backToAssignments: "Retour aux devoirs", complete: "Mission terminée !",
    completeDesc: "Vous avez terminé {title}.",
    myAssignments: "Mes devoirs", dashboard: "Tableau de bord", yourClass: "Ta classe",
    stepOf: "Étape {current} sur {total}", optional: "facultatif",
    back: "Retour", nextStep: "Étape suivante", continueBonus: "Continuer vers le bonus",
    completeMission: "Terminer la mission", finishEarly: "J'ai fini — terminer la mission",
    keepWords: "Garder ces mots pour votre pratique personnelle ?", saveToBank: "Enregistrer dans ma banque de vocabulaire", notNow: "Pas maintenant", savedToBank: "Enregistré dans votre banque de vocabulaire.", backToClass: "Retour à la classe", cantSave: "Ces mots ne peuvent pas être enregistrés dans votre banque de vocabulaire, car la langue de cette mission ne fait pas partie de vos langues d'apprentissage.", saveFailed: "Impossible d'enregistrer les mots. Veuillez réessayer.",
  },
  lensDesc: {
    text: "Traduis des passages difficiles et comprends le vocabulaire et la grammaire.",
    object: "Découvre comment une chose s'appelle et apprends la langue qui l'entoure.",
    scene: "Observe toute la scène : décris-la, compte les choses et apprends la langue autour.",
    study: "Transforme la lecture du monde réel en exercices de compréhension.",
    archiveSub: "Rouvre d'anciens scans, révise le vocabulaire, refais des sessions d'étude.",
    hintText: "Vise un livre, un panneau, un menu ou une lettre", hintObject: "Vise un objet, une plante ou un animal",
    hintScene: "Vise un repas, une table, une pièce ou un paysage", captureHelp: "Prends une photo ou importes-en une.",
    subText: "Scanne un texte pour le traduire, l'expliquer ou l'étudier.",
    subObject: "Vise quelque chose pour apprendre son nom et la langue autour.",
    subScene: "Observe toute la scène. Apprends la langue qui l'entoure.",
    subStudy: "Scanne un texte et entraîne-toi à le comprendre.",
    captureSub: "Prends ou importe une photo de n'importe quel objet pour en apprendre le mot.",
  },
  todayHelp: {
    refresh: "Rafraîchis ce qui s'estompe", score: "Évalue ta prononciation",
    snap: "Photographie un objet", proFeature: "Fonction Pro", proScoring: "L'évaluation de la prononciation est une fonction Pro",
  },
  capture: {
    title: "Qu'y a-t-il autour de toi ?", reading: "Lecture du monde…",
    pointHint: "Vise une tasse, un arbre, un chien…", anything: "N'importe quoi fonctionne.",
    learnMe: "Apprendre", savedToBank: "Enregistré dans ton lexique", shareCard: "Carte à partager",
    building: "Création…", capReached: "Tu as atteint tes captures gratuites du jour.",
    keepStreak: "Garde ta série !", signUpFree: "Inscription gratuite", close: "Fermer",
    couldNotRead: "Impossible de lire cette image. Essaies-en une autre.",
  },
  review: {
    title: "Révision", tagline: "Retiens ce qui compte.",
    progress: "{n} sur {total}",
    dueCount: { one: "1 mot est prêt à réviser.", other: "{count} mots sont prêts à réviser." },
    recentCount: { one: "Pratique 1 mot récent.", other: "Pratique {count} mots récents." },
    allDue: "Tous ceux à réviser", all: "Tous", start: { one: "Commencer · 1 carte", other: "Commencer · {count} cartes" },
    caughtUp: "Tu es à jour.", nothingDue: "Rien à réviser pour le moment.", practiceRecent: "Pratiquer les mots récents",
    reveal: "Afficher", again: "Encore", gotIt: "Je sais", listen: "Écouter",
    type: { recognition: "Qu'est-ce que ça veut dire ?", recall: "Comment dit-on ?", context: "Quel mot convient ?", listening: "Écoute : qu'est-ce que c'est ?", typed: "Écris-le de mémoire" },
    typed: { label: "Écris ta réponse", placeholder: "Écris-le en {lang}", check: "Vérifier", correct: "Correct", notQuite: "Pas tout à fait", yourAnswer: "Ta réponse", answer: "Réponse", showAnswer: "Voir la réponse", suggestAgain: "À revoir : « Encore » le fait revenir plus tôt.", checkFailed: "Impossible de vérifier. Réessaie." },
    complete: "Révision terminée", reviewed: "Révisées", remembered: "Retenues", anotherLook: "À revoir",
    nextIn: { one: "Prochaine révision dans 1 jour.", other: "Prochaine révision dans {count} jours." },
    done: "Terminé", backToday: "Retour à Aujourd'hui", todayLink: { one: "Retiens · 1 mot à réviser", other: "Retiens · {count} mots à réviser" },
    voiceUnavailable: "La voix n'est pas disponible pour le moment.", saveFailed: "Impossible d'enregistrer. Réessaie.",
  },
  lc: {
    "title": "Tes 5 minutes",
    "subtitle": "Créé à partir de ce que tu apprends en ce moment",
    "cold": "Ton parcours quotidien deviendra plus personnel à mesure que FluentLoop découvre ce qui compte pour toi.",
    "forYou": "Pour toi aujourd'hui",
    "assigned": "Assigné",
    "reason": {
      "due": "Ça revient au bon moment",
      "weak": "À retravailler",
      "activation": "Tu l'as déjà vu, mais pas encore utilisé",
      "relevant": "Enregistré récemment",
      "recently_saved": "Enregistré récemment",
      "stretch": "Va un peu plus loin",
      "function_gap": "Une compétence utile à pratiquer",
      "skill": "Une compétence utile à pratiquer"
    },
    "kind": {
      "recall": "Souviens-toi",
      "retrieve": "Souviens-toi",
      "use_it": "Utilise-le",
      "situation": "Situation"
    },
    "howSay": "Comment dit-on cela ?",
    "write": "Écris ta réponse…",
    "check": "Vérifier",
    "skip": "Passer",
    "notUseful": "Pas utile pour moi",
    "next": "Suivant",
    "natural": "Naturel",
    "tip": "Astuce",
    "alreadyNatural": "Ta phrase est déjà naturelle.",
    "example": "Exemple",
    "saved": "Enregistré",
    "useItTpl": "Utilise « {word} » dans une phrase.",
    "useItTopicTpl": "Utilise « {word} » dans une phrase sur {topic}.",
    "situationTpl": "{function} : écris 1 à 2 phrases sur {topic}.",
    "doneTitle": "C'est assez pour aujourd'hui.",
    "recalled": "{count} rappelés",
    "used": "{count} utilisés",
    "situations": "{count} situation pratiquée",
    "keepGoing": "Continuer",
    "reviewAll": "Réviser tous les mots dus ({count})",
    "sayAloud": "Dire une phrase à voix haute",
    "snapWord": "Photographier un nouveau mot",
    "alsoToday": "Aussi aujourd'hui",
    "progress": "{n} sur {total}",
    "loading": "Préparation de tes 5 minutes…",
    "fn": {
      "asking_question": "Poser une question",
      "requesting": "Faire une demande",
      "explaining_problem": "Expliquer un problème",
      "describing": "Décrire quelque chose",
      "narrating_past": "Raconter ce qui s'est passé",
      "making_plans": "Faire des projets",
      "apologizing": "S'excuser",
      "agreeing_disagreeing": "Être d'accord ou pas",
      "expressing_preference": "Dire ce que tu préfères",
      "giving_opinion": "Donner ton avis",
      "clarifying": "Clarifier",
      "small_talk": "Bavarder"
    },
    "topic": {
      "home": "la maison",
      "work": "le travail",
      "study": "les études",
      "food": "la nourriture",
      "travel": "les voyages",
      "transport": "les déplacements",
      "shopping": "les courses",
      "social_life": "les amis et les sorties",
      "health_everyday": "le bien-être au quotidien",
      "money_everyday": "les dépenses du quotidien",
      "hobbies": "les loisirs",
      "culture": "la culture",
      "nature": "la nature",
      "technology": "la technologie",
      "everyday_life": "la vie quotidienne"
    }
  },
  errors: {
    generic: "Une erreur s'est produite. Réessaie.",
    couldNotSave: "Impossible d'enregistrer. Réessaie.",
  },
};
fr.pm = pm;
fr.lvl = lvl;
fr.iv = iv;
fr.vm = vm;
fr.edu = edu;
fr.lib = lib;
fr.al = al;
export default fr;
